export default {
  path: '/departments',
  name: 'departments',
  component: () => import(/* webpackChunkName: "departments" */ './Departments.vue'),
  meta: {
    requiresAuth: true,
    pageTitle: 'Departments'
  }
}
